module.exports = __webpack_public_path__ + "img/logo-zgrb.762e85a2.png";